import { useEffect } from 'react';

import { HEADER_DESKTOP_MEDIA_QUERY } from './model';

/** Closes an open overlay once the viewport hides the control that opened it. */
export function useCloseAcrossBreakpoint({
  open,
  close,
  openerVisibleOnDesktop,
}: {
  open: boolean;
  close: () => void;
  openerVisibleOnDesktop: boolean;
}) {
  useEffect(() => {
    if (!open) return undefined;
    const desktop = window.matchMedia(HEADER_DESKTOP_MEDIA_QUERY);
    const closeWhenOpenerHidden = () => {
      if (desktop.matches !== openerVisibleOnDesktop) close();
    };
    desktop.addEventListener('change', closeWhenOpenerHidden);
    return () => desktop.removeEventListener('change', closeWhenOpenerHidden);
  }, [close, open, openerVisibleOnDesktop]);
}
